import {
  CompanyBuilder,
  EditPositionEnhancedInput,
  EditPositionEnhancedOutput,
} from '../companies.types';

export const editPositionEnhanced = (builder: CompanyBuilder) =>
  builder.mutation<EditPositionEnhancedOutput, EditPositionEnhancedInput>({
    query: ({ positionId, ...payload }) => ({
      url: `/positions/enhanced/${positionId}`,
      method: 'PATCH',
      body: { ...payload },
    }),
    invalidatesTags: () => [{ type: 'Company' }],
  });
